export const getPreviousTrait = (allTraits, traitToDisplayIndex) => {
  let previousTraitIndex = traitToDisplayIndex - 1;
  if (previousTraitIndex <= 0) {
    previousTraitIndex = allTraits.length - 1;
  }

  return allTraits[previousTraitIndex].trait.code;
};

export const getNextTrait = (allTraits, traitToDisplayIndex) => {
  let nextTraitIndex = traitToDisplayIndex + 1;
  if (nextTraitIndex >= allTraits.length) {
    nextTraitIndex = 0;
  }

  return allTraits[nextTraitIndex].trait.code;
};
